import { render, staticRenderFns } from "./ModalAddNewParticipant.vue?vue&type=template&id=70b6ee02&scoped=true&"
import script from "./ModalAddNewParticipant.vue?vue&type=script&lang=js&"
export * from "./ModalAddNewParticipant.vue?vue&type=script&lang=js&"
import style0 from "./ModalAddNewParticipant.vue?vue&type=style&index=0&id=70b6ee02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b6ee02",
  null
  
)

export default component.exports